const ApplicationEventTypes = {
  UndoRedoEvents: {
    ADDED:                    'addIntoPageWiseUndoRedoArray',
    PRODUCT_UPDATED:          'updateProductByPageWiseUndoRedo',
    RESET_PAGE_UNDO_REDO:     'resetPageUndoRedoArray',
    PRODUCT_DURATION_UPDATED: 'updateProductPagesDurationUndoRedo',
  },
  ProductPageEvents: {
    PAGE_CHANGE:                      'onChangeProductPage',
    PAGE_DELETE:                      'onDeleteProductPage',
    PAGE_DUPLICATE:                   'productPageDuplicate',
    PAGE_CREATE:                      'productNewPageCreate',
    PAGE_DURATION_UPDATE:             'updateProductPageDuration',
    ACTIVE_PAGE_DURATION_UPDATE:      'updateActivePageDuration',
    UPDATE_PRODUCT_TRANSITION_OBJECT: 'updateProductTransitionObjects',
    UPDATE_PAGE_UNDO_REDO_OBJ:        'updatePageUndoRedoObject',
    UPDATE_PRODUCT_PAGES_DURATION:    'calculateAllPagesDuration',
    PRODUCT_PAGES_SHOULD_BE_SAME:     'InVideoModeAllPagesShouldBeSame',
  },
  ObjectSelectionEvents: {
    SELECTED:                  'onObjectSelected',
    UPDATED:                   'onObjectUpdated',
    CLEARED:                   'clearAllSelection',
    SELECTED_FROM_RIGHT_PANEL: 'onObjectSelectedFromRightPanel',
    SET_TARGET_EMPTY:          'setTargetEmpty',
    ZOOM_CHANGE:               'setZoomLevel',
    OBJECT_DELETED:            'deleteObject',
    OBJECT_DUPLICATE:          'duplicateObject',
    COLOR_PICKER_ENABLE:       'colorPickerEnable',
    SHOW_HIDE_MOVEABLE_EDGES:  'showHideMoveableEdges',
    UPDATE_OBJECT_ALIGNMENT:   'updaetObjectAlignment',
    FLIP_OBJECT:               'flipObject',
    ROTATE_OBJECT:             'rotateObject',
  },
  ImageObjectEvents: {
    ADDED:                         'onAddingNewObjectImage',
    REPLACED:                      'onReplaceImage',
    REPLACED_ADDRESS_PHOTO:        'onReplaceAddressBoxImage',
    SELECTED_IMAGE_FOR_LEFT_PANEL: 'onSelectingImageForLeftPanel',
    CHANGE_FDIC_PHOTO:             'changeFdicPhoto',
    CHANGE_HOUSING_PHOTO:          'changeHousingPhoto',
    SELECTED_VIDEO_FOR_LEFT_PANEL: 'onSelectingVideoForLeftPanel',
    REPLACE_VIDEO:                 'onChangeVideoVariation',
  },
  ShapeObjectEvents: {
    ADD_RECTANGLE: 'addRectangleObjectToCanvas',
    ADD_CIRCLE:    'addCircleObjectToCanvas',
    ADD_POLYGON:   'addPolygonObjectToCanvas',
  },
  TextObjectEvents: {
    UPDATED:                'updateTextProperties',
    TEXT_EDITOR_ADDED:      'AddTextEditorInEditorList',
    TEXT_SELECTION_UPDATED: 'GetTextSelectionProperties',

  },
  LeftPanelEvents: {
    RESET:                             'resetLeftPanel',
    CHANGE_FONT_SIZE:                  'changeFontSize',
    CHANGE_LINE_HEIGHT:                'changeLineSpacing',
    CHANGE_TEXT_COLOR:                 'changeTextColor',
    CHANGE_TEXT_SHADOW_COLOR:          'changeTextShadowColor',
    CHANGE_TEXT_OUTLINE_COLOR:          'changeTextOutlineColor',
    CHANGE_FONT_FAMILY:                'changeFontFamily',
    CHANGE_SHAPE_COLOR:                'changeShapeColor',
    CHANGE_SHAPE_STROKE:               'changeShapeStroke',
    CHANGE_SHAPE_STROKE_WIDTH:         'changeShapeStrokeWidth',
    CHANGE_SVG_FILL_COLOR:             'changeSvgFillColor',
    CHANGE_SVG_STROKE_COLOR:           'changeSvgStrokeColor',
    RESET_PRODUCT_SIZE:                'setDefaultProduct',
    CLOSE_PRODUCT_SIZE_DROPDOWN:       'closeSizeDropDown',
    CHANGE_PRODUCT_SIZE_FROM_DROPDOWN: 'changeProductSizeFromDropDown',
  },
  ProductLoadingEvents: { UPDATE_HTML_AFTER_ENABLE_EDITOR: 'updateHTML' },
  LayerPanelEvents:     { UPDATE_DATA_ON_LAYER_SWAP: 'UpdateContentListIndexOnLayerSwap' },
  ModalEvents:          {
    SHOW_SIZE_MODAL:           'showSizeModal',
    TOGGLE_CONFIRMATION_MODAL: 'confirmationModelToggle',
    TOGGLE_CROP_IMAGE_MODAL:   'toggleCropImage',
  },
  AnimationEvent: {
    STOP_OBJECT_ANIMATION: 'stopObjectAnimation',
    SET_ELEMENT_ANIMATION: 'SetElementAnimation',
  },
  AnimationEvents: {
    SHOW_SIZE_MODAL:           'showSizeModal',
    TOGGLE_CONFIRMATION_MODAL: 'confirmationModelToggle',
    TOGGLE_CROP_IMAGE_MODAL:   'toggleCropImage',
  },
  TransitionEvents: {
    ADD_TRANSITION:     'addTransition',
    UPDATE_TRANSITION:  'updateTransition',
    PREVIEW_TRANSITION: 'previewTransition',
  },
  Video: {
    ADD_NEW_VIDEO_ON_CANVAS:                    'AddNewVideoOnCanvas',
    TRIM_VIDEO:                                 'trimVideo',
    ToggleVideoMood:                            'toggleVideoMood',
    UPDATE_VIDEO_URL_ATTR_IN_PRODUCT:           'updateVideoAttrInProduct',
    UPDATE_VIDEO_WATERMARK_URL_ATTR_IN_PRODUCT: 'updateVideoMarkAttrInProduct',
    UPDATE_VIDEO_GIF_URL_ATTR_IN_PRODUCT:       'uodateVideoGifAttrInProduct',
  },
  Audio: {
    ADD_NEW_AUDIO: 'AddNewAudio',
  },
  ProductSave: {
    SAVE_PRODUCT_AS_TEMPLATE: 'saveProductAsTemplate',
  },
};

ApplicationEventTypes.Mixin = {
  created() {
    this.ApplicationEventTypes = ApplicationEventTypes;
  },
};
export default ApplicationEventTypes;
